import { render } from "./SSTRepository.vue?vue&type=template&id=bbf4f02e"
import script from "./SSTRepository.vue?vue&type=script&lang=js"
export * from "./SSTRepository.vue?vue&type=script&lang=js"
script.render = render

export default script